// extracted by mini-css-extract-plugin
export default {"link":"YVH2YK17PilpPCqzu5hx"};